import styled from 'styled-components';
import { Text, FontWeight } from '../Text';
import Colors from '../../constants/Colors';

export const Container = styled.div`
  position: relative;
  padding: 16px;
  box-shadow: 0px 4px 5px 1px #ddd;
  border-radius: 10px;
  width: 100%;
  float: left;
  margin: 20px 0px;
`;

export const Title = styled(Text)`
  font-size: 15px;
  margin: 0px 20px 20px 0px;
  font-weight: 500;
  width: 100%;
  display: block;
`;

export const Value = styled(Text)`
  font-size: 26px;
  margin-top: 20px;
  margin-bottom: 20px;
  font-weight: ${FontWeight.Black};
  width: 100%;
  display: block;
`;

export const SubTitle = styled(Text)`
  font-size: 12px;
  text-align: right;
  width: 100%;
  margin: 10px 0px;
  display: block;
`;

export const Result = styled(Text)`
  font-size: 18px;
  text-align: right;
  width: 100%;
  margin: 10px 0px;
  display: block;
  color: #629c1e;
  font-weight: ${FontWeight.Black};
`;